import * as React from 'react'
import { Alert } from "@material-ui/lab";

export default function Alerts(props: { wait: boolean; created: boolean; deleted: boolean; notPossible: boolean; }) {
    return (
        <div className="App-alerts">
            {props.wait && <Alert severity="info">Odota. Varausta luodaan/poistetaan.</Alert>}
            {props.created && <Alert severity="success">Varaus luotu</Alert>}
            {props.deleted && <Alert severity="warning">Varaus poistettu</Alert>}
            {props.notPossible && <Alert severity="warning">Varausta ei voi luoda/poistaa</Alert>}
        </div>
    )
}